import React from 'react';
import { t } from 'react-switch-lang';

const returnDataTitle = (idCase, data) => {
  switch (idCase) {
    
    default:
      return '';
  }
};

export default returnDataTitle;
